import React from 'react';
import SubjectPage from '../../Subjects/SubjectPage';

function RepeatedPYQ() {

    const pageTitleText = "JEE Top 500 Important PYQ ";

  return (
    <>
    
      <SubjectPage 
        name={pageTitleText} 
        link="repeated-pyq" 
      />

    </>
  );
}

export default RepeatedPYQ;